import React from 'react'
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';


const mapStateToProps = (state, ownProps) => ({
    translationStrings: state.getIn(['translation', 'strings', ownProps.id]),
    currentLang: state.getIn(['translation', 'currentLang'])
})

export const getTranslationString = (translationStrings, currentLang, defaultString) => {
    if(translationStrings && translationStrings.hasOwnProperty(currentLang) && translationStrings[currentLang]) {
        return translationStrings[currentLang]
    } else if(defaultString) {
        return defaultString
    } else {
        return ''
    }
}


export const TranslationCont = ({
    id, 
    currentLang, 
    translationStrings, 
    children,
    before="", 
    after="", 
    uppercase=false
}) => {
    let transString = getTranslationString(translationStrings, currentLang, children)

    if(before) {
        transString = before + transString
    }

    if(after) {
        transString = transString + after
    }

    if(uppercase) {
        transString = transString.toUpperCase()
    }

    return transString
}

export default compose(
    connect(mapStateToProps, null),
    toJS(),
)(TranslationCont)